export function Capitalize(text = ''): string {
  return text
    .split(' ')
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
}

export function CapitalizeMarkedText(text = '', capitalizeAll = false): string {
  if (!text) return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${text}</div>`, 'text/html');
  const container = doc.body.firstChild as HTMLElement;

  // Flatten all text nodes
  const textNodes: { node: Text; start: number; end: number }[] = [];
  let fullText = '';
  let offset = 0;

  function collectTextNodes(node: Node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const textContent = node.textContent || '';
      const start = offset;
      const end = offset + textContent.length;
      fullText += textContent;
      textNodes.push({ node: node as Text, start, end });
      offset = end;
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      for (const child of Array.from(node.childNodes)) {
        collectTextNodes(child);
      }
    }
  }

  collectTextNodes(container);

  // Capitalize logic
  const modifiedText = capitalizeAll
    ? fullText.replace(/\b\w/g, (c) => c.toUpperCase())
    : fullText.replace(/\b\w/, (c) => c.toUpperCase());

  // Write back to text nodes
  for (const { node, start, end } of textNodes) {
    node.textContent = modifiedText.slice(start, end);
  }

  return container.innerHTML;
}
